import React from 'react'
import styles from './EnvBanner.module.css'
import { currentRelease } from '../lib/release'

// UAT says so on every screen, sign-in included: a red band across the top so
// nobody mistakes it for production or keeps real work there. Production and
// local builds show nothing. While it shows, --dp-env-banner holds its height
// so the full-height shell fits beneath it.

export function envBannerText(env: string): string | null {
  if (env !== 'uat') return null
  return 'UAT test environment: for testing only. Data here can be changed, reset or lost at any time. Do not enter real work you need to keep.'
}

export function EnvBanner({ env = currentRelease().env }: { env?: string }) {
  const text = envBannerText(env)
  React.useLayoutEffect(() => {
    if (!text) return
    document.documentElement.style.setProperty('--dp-env-banner', '2.25rem')
    return () => {
      document.documentElement.style.removeProperty('--dp-env-banner')
    }
  }, [text])
  if (!text) return null
  return (
    <div className={styles.banner} role="note" aria-label="Test environment">
      <strong>UAT</strong>
      <span>{text}</span>
    </div>
  )
}
